import { useEffect, useState } from 'react';
import {
  Button,
  Celebration,
  Confetti,
  ExerciseCard,
  Skeleton,
  Spinner,
  ThemeToggle,
} from '@fluent/ui';
import './Cluster5Review.css';

export function Cluster5Review() {
  const [celebOpen, setCelebOpen] = useState(false);
  const [burst, setBurst] = useState(0);
  const [loading, setLoading] = useState(true);

  // Auto-flip "loading" every ~2.5s so Tornike sees skeleton → content → skeleton
  useEffect(() => {
    const id = window.setInterval(() => setLoading((v) => !v), 2500);
    return () => window.clearInterval(id);
  }, []);

  return (
    <main className="c5">
      <Confetti trigger={burst} originY={0.3} />

      <header className="c5__hero">
        <p className="c5__kicker">Phase 1 · Cluster 5</p>
        <h1>Feedback &amp; celebration</h1>
        <p className="c5__lede">
          The moments that make the app feel alive — loading states, little bursts, and the big lesson-complete screen.
        </p>
        <div className="c5__theme-row">
          <ThemeToggle />
        </div>
      </header>

      {/* Spinner */}
      <section className="c5__section">
        <h2>Spinner</h2>
        <p className="c5__note">Three sizes, five tones. Shows while the app is waiting on the network.</p>
        <div className="c5__row">
          <Spinner size={20} tone="neutral" />
          <Spinner size={28} tone="primary" />
          <Spinner size={40} tone="accent" />
          <Spinner size={56} tone="info" />
          <Spinner size={72} tone="danger" />
        </div>
      </section>

      {/* Skeleton */}
      <section className="c5__section">
        <h2>Skeleton</h2>
        <p className="c5__note">
          Shimmer placeholder shown while content loads. Auto-swaps with real content every ~2.5s so you can see the
          transition.
        </p>

        {loading ? (
          <div className="c5__skeleton-stack">
            <Skeleton width={140} height={16} />
            <Skeleton width="100%" height={24} shape="block" />
            <Skeleton width="80%" height={16} />
            <div className="c5__skeleton-row">
              <Skeleton width={56} height={56} shape="circle" />
              <div className="c5__skeleton-col">
                <Skeleton width="60%" height={14} />
                <Skeleton width="40%" height={12} />
              </div>
            </div>
            <Skeleton width="100%" height={160} shape="card" />
          </div>
        ) : (
          <div className="c5__skeleton-stack">
            <p className="c5__real-kicker">LESSON PREVIEW</p>
            <h3 className="c5__real-title">ოჯახი — გაკვეთილი 2</h3>
            <p className="c5__real-body">
              ისწავლე ოჯახის წევრების სახელები და როგორ წარადგინო ისინი ინგლისურად.
            </p>
            <div className="c5__skeleton-row">
              <div className="c5__real-avatar">🎯</div>
              <div className="c5__skeleton-col">
                <span className="c5__real-label">4 გაკვეთილი</span>
                <span className="c5__real-sub">~15 წუთი</span>
              </div>
            </div>
            <ExerciseCard compact kicker="მაგალითი" prompt="“Meet my sister”">
              <p style={{ margin: 0, color: 'var(--color-text-muted)' }}>
                ჩემი დის წარდგენა ინგლისურად.
              </p>
            </ExerciseCard>
          </div>
        )}
      </section>

      {/* Confetti */}
      <section className="c5__section">
        <h2>Confetti</h2>
        <p className="c5__note">
          Small burst for correct answers. Particles fly up, gravity pulls them down, fade out. Uses the brand palette.
        </p>
        <div className="c5__row">
          <Button variant="primary" onClick={() => setBurst((n) => n + 1)}>
            🎉 ტესტი
          </Button>
        </div>
      </section>

      {/* Celebration */}
      <section className="c5__section">
        <h2>Celebration</h2>
        <p className="c5__note">
          The full-screen overlay that appears when a lesson completes. Trophy, title, stats, confetti, Continue.
        </p>
        <div className="c5__row">
          <Button variant="primary" size="lg" onClick={() => setCelebOpen(true)}>
            დაასრულე გაკვეთილი
          </Button>
        </div>
      </section>

      <footer className="c5__footer">
        <p>
          <b>Cluster 5 review.</b> Tell Jake: spinner speed, skeleton shimmer, confetti feel, celebration pop-in timing.
        </p>
      </footer>

      <Celebration
        open={celebOpen}
        title="დასრულდა!"
        subtitle="ოჯახი — გაკვეთილი 2. საუცხოო შედეგი!"
        stats={[
          { label: 'XP', value: '+15' },
          { label: 'ზუსტი', value: '100%' },
          { label: 'დრო', value: '1:24' },
        ]}
        onContinue={() => setCelebOpen(false)}
      />
    </main>
  );
}
